'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/**
 *
 */
var REMOTE_CREATE = exports.REMOTE_CREATE = 'vtech-chat/discussions/REMOTE_CREATE';
var REMOTE_CREATE_SUCCESS = exports.REMOTE_CREATE_SUCCESS = 'vtech-chat/discussions/REMOTE_CREATE_SUCCESS';
var REMOTE_UPDATE = exports.REMOTE_UPDATE = 'vtech-chat/discussions/REMOTE_UPDATE';
var REMOTE_UPDATE_SUCCESS = exports.REMOTE_UPDATE_SUCCESS = 'vtech-chat/discussions/REMOTE_UPDATE_SUCCESS';
var ADD = exports.ADD = 'vtech-chat/discussions/ADD';
var ADD_REQUEST = exports.ADD_REQUEST = 'vtech-chat/discussions/ADD_REQUEST';
var SET = exports.SET = 'vtech-chat/discussions/SET';
var UPDATE = exports.UPDATE = 'vtech-chat/discussions/UPDATE';
var SUBSCRIBE = exports.SUBSCRIBE = 'vtech-chat/discussions/SUBSCRIBE';

/**
 *	Creates a discussion on the server.
 */
var remoteCreate = exports.remoteCreate = function remoteCreate(chatId, subject, participants) {
	return {
		type: REMOTE_CREATE,
		meta: {
			chatId: chatId
		},
		payload: {
			subject: subject,
			participants: participants
		}
	};
};

/**
 *	Acknowledges a successful creation.
 */
var remoteCreateSuccess = exports.remoteCreateSuccess = function remoteCreateSuccess(chatId, discussion) {
	return {
		type: REMOTE_CREATE_SUCCESS,
		meta: {
			chatId: chatId
		},
		payload: {
			discussion: discussion
		}
	};
};

/**
 *
 */
var remoteUpdate = exports.remoteUpdate = function remoteUpdate(chatId, id, fields) {
	return {
		type: REMOTE_UPDATE,
		meta: {
			chatId: chatId,
			id: id
		},
		payload: {
			fields: fields
		}
	};
};

/**
 *	Acknowledges a successful creation.
 */
var remoteUpdateSuccess = exports.remoteUpdateSuccess = function remoteUpdateSuccess(chatId, discussion) {
	return {
		type: REMOTE_UPDATE_SUCCESS,
		meta: {
			chatId: chatId
		},
		payload: {
			discussion: discussion
		}
	};
};

/**
 *	Adds a discussion to the store.
 */
var add = exports.add = function add(chatId, discussion) {
	return {
		type: ADD,
		meta: {
			chatId: chatId
		},
		payload: {
			discussion: discussion
		}
	};
};

/**
 *	Adds a discussion to the store.
 */
var addRequest = exports.addRequest = function addRequest(chatId, discussion) {
	return {
		type: ADD_REQUEST,
		meta: {
			chatId: chatId
		},
		payload: {
			discussion: discussion
		}
	};
};

/**
 *	Sets all discussions of a given chat.
 */
var set = exports.set = function set(chatId, discussions) {
	return {
		type: SET,
		meta: {
			chatId: chatId
		},
		payload: {
			discussions: discussions
		}
	};
};

/**
 *
 */
var update = exports.update = function update(chatId, discussion) {
	return {
		type: UPDATE,
		meta: {
			chatId: chatId
		},
		payload: {
			discussion: discussion
		}
	};
};

/**
 *
 */
var subscribe = exports.subscribe = function subscribe(chatId, id) {
	return {
		type: SUBSCRIBE,
		payload: {
			chatId: chatId,
			id: id
		}
	};
};